"use client";

import { PageLoading } from "@/shared/components/Loading";

export default function AppLoading() {
  return <PageLoading message="Loading OmniRoute..." />;
}
